<template>
  <div class="form-row">
    <div class="form-label">{{ info.displayName }}</div>
    <div class="form-contro">
      <a-checkbox
        v-for="o in info.listOptions"
        :key="o.optionValue"
        @change="info.setValue()"
        :value="o.optionValue"
        :disabled="info.disabled"
        v-model="o.checked"
      >
        {{ o.optionValue }}
      </a-checkbox>
    </div>
    <div class="form-error" v-if="info.dirty && info.invalid">
      {{ info.validationMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SCheckbox",
  props: {
    info: {}
  }
};
</script>

<style scoped></style>
